import React from 'react'
import CardSetHeader from '../cardSetHeader'

export default function StoreTitle(props) {
    return (
        <CardSetHeader
            title={props.storeName + " " + props.revenueCommission.substring(0,1).toUpperCase() + props.revenueCommission.substring(1)}
            onAddHidden={props.onAddHidden}
            setName={props.setName}
        />
    )
}